﻿@Component('Umbrella', {
    selector: 'vendor-role-label',
    template: `
        <role-label label-text="LV" label-title="Leverancier"></role-label>
    `
})
class VendorRoleLabelComponent {}
